import { Radio, RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/20/solid'

import GenericInput, { FormComponent } from '@/components/GenericForm/GenericInput'
import cn from '@/utilities/cn'

type RadioCardOption = { key: string; title: string; description: string; tooltip: string }
export interface RadioCardsProps extends FormComponent<string> {
  options: RadioCardOption[]
}

export const RadioCards = ({ value, onChange, options, formatProps, disabled = false }: RadioCardsProps) => {
  return (
    <GenericInput {...formatProps}>
      <RadioGroup
        disabled={disabled}
        value={value}
        name={formatProps.name}
        onChange={onChange}
        className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4"
      >
        {options.map(option => (
          <Radio
            key={option.key}
            value={option.key}
            aria-label={option.title}
            aria-description={`${option.description}`}
            className="group relative flex cursor-pointer rounded-lg border border-zinc-300 bg-white p-4 shadow-sm focus:outline-none data-[focus]:border-brand-400 data-[focus]:ring-2 data-[focus]:ring-brand-400"
          >
            <span className="flex flex-1">
              <span className="flex flex-col">
                <span className="block text-sm font-bold text-zinc-900">{option.title}</span>
                <span className="mt-1 flex items-center text-sm text-zinc-500">{option.description}</span>
              </span>
            </span>
            <CheckCircleIcon
              aria-hidden="true"
              className={`h-5 w-5 ${
                disabled ? 'text-zinc-400' : 'text-brand-400'
              } [.group:not([data-checked])_&]:invisible`}
            />
            <span
              aria-hidden="true"
              className={cn(
                'pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-brand-400',
                { 'group-data-[checked]:border-zinc-300': disabled }
              )}
            />
          </Radio>
        ))}
      </RadioGroup>
    </GenericInput>
  )
}
